import { makeCygnusApiCall } from "../../../api/api";

/**
 * Fetches audit trail or flow log data based on ClientId, Category, and optional date range with pagination.
 *
 * @param clientMasterId - Client identifier
 * @param clientId - Client identifier
 * @param category - Optional category filter (Client, Engagement Letter, FlowLogs, All)
 * @param options - Object with { offset, limit, startDate, endDate } for pagination and date filtering
 * @returns Promise resolving to { records, totalCount }
 */
export const fetchAuditTrailData = async (
  clientMasterId?: number,
  clientId?: string,
  category?: string | null,
  options?: { offset: number; limit: number; startDate?: string | null; endDate?: string | null, cumulativeFilteredCount?: number }
): Promise<{ records: any[]; totalCount: number, nextOffset?: number, cumulativeFilteredCount?: number }> => {
  let params = "";

  if (category) params += `?Category=${encodeURIComponent(category)}`;
  if (clientMasterId)
    params = params ? `${params}&ClientMasterId=${clientMasterId}` : `?ClientMasterId=${clientMasterId}`;
  if (clientId)
    params = params ? `${params}&ClientId=${clientId}` : `?ClientId=${clientId}`;
  if (options?.offset !== undefined && options?.limit !== undefined)
    params += `${params ? "&" : "?"}Offset=${options.offset}&Limit=${options.limit}`;
  if (options?.startDate)
    params += `${params ? "&" : "?"}StartDate=${encodeURIComponent(options.startDate)}`;
  if (options?.endDate)
    params += `${params ? "&" : "?"}EndDate=${encodeURIComponent(options.endDate)}`;
  if (options?.cumulativeFilteredCount !== undefined)
    params += `${params ? "&" : "?"}CumulativeFiltered=${options.cumulativeFilteredCount}`;
  
  const response = await makeCygnusApiCall({
    type: "GET",
    url: `/audit_trail/${params}`,
    show_message: false,
    customized_failure_message: "Failed to fetch audit trail data.",
    customized_error_message: "Error occurred while fetching audit trail data.",
    isblob: false,
    forMDM: true,
  });

  if (response?.success) {
    return response.data;
  }

  return { records: [], totalCount: 0 };
};
